module.exports = __webpack_public_path__ + "img/191.86867aa5.jpg";